import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../../Checkbox';

// Non-dropdown lists display
const OptionsList = ({ options, selectedValues, onChange, selectSingleRateCode }) => (
  <>
    {options.map((item) => (
      <Fragment key={item.value}>
        <div className="flex justify-between space-y-1">
          <Checkbox
            checked={selectedValues.includes(item.value)}
            name={item.label}
            onChange={(event, newValue) => onChange(item.value, newValue)}
            value={item.value}
            label={item.label}
            key={item.value}
            checkboxStyles={{
              padding: '5px',
            }}
          />
          {selectSingleRateCode && (
            <a
              className="underline self-center"
              tabIndex="-1"
              role="button"
              onClick={() => selectSingleRateCode(item.value)}
              onKeyDown={() => {}}
            >
              <span>Only</span>
            </a>
          )}
        </div>
        {selectedValues.includes(item.value) && item.inputElement ? item.inputElement : ''}
      </Fragment>
    ))}
  </>
);

OptionsList.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedValues: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
    .isRequired,
  onChange: PropTypes.func.isRequired,
  selectSingleRateCode: PropTypes.func,
};
OptionsList.defaultProps = {
  selectSingleRateCode: undefined,
};
export default OptionsList;
